import { AutoComplete, FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import MainApiService from "../../../../../services/mainApi.service";
import { listCampaigns } from "../../../../../services/registerCampaign.service";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApiService(GENERICS_ROUTE);

const translationPath = "page.4uMarCom.automationRules.";

export const BasicData = memo(() => {
  const { t } = useTranslation();

  const paramMarcomtype = useMemo(() => {
    return { identifier: "MarComType" };
  }, []);

  const paramSendtype = useMemo(() => {
    return { identifier: "MarComSendType" };
  }, []);
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <SwitchInput
          name="enable"
          label={t(translationPath + "enable") || "Enable"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="name"
          fullWidth
          label={t(translationPath + "name") || "Name"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          params={paramMarcomtype}
          getOptionLabel={(option) => option.name}
          size="small"
          label={t(translationPath + "marcom_type") || "MarCom Type"}
          name="marComType"
          request={genericService.list}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AutoComplete
          params={paramSendtype}
          getOptionLabel={(option) => option.name}
          size="small"
          label={t(translationPath + "send_ype") || "Send Type"}
          name="sendType"
          request={genericService.list}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          getOptionLabel={(option) => option.name}
          size="small"
          label={t(translationPath + "campaign") || "Campaign"}
          name="campaign"
          request={listCampaigns}
        />
      </Grid>
    </>
  );
});
